import {postChangePassword} from '../api/postChangePassword';

const setChangePassword = (params) => {
    return async (dispatch, getState) => {
        try {
            await postChangePassword(params);
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setChangePassword
}